import { useQuery } from "@apollo/client";
import { OrganizationEventsPreviewDocument } from "../../__generated__/graphql";

export default function useOrganizationEventsPreview({
  afterDate,
  beforeDate,
}: {
  afterDate: string | null;
  beforeDate: string | null;
}) {
  const { data, loading, error, refetch } = useQuery(
    OrganizationEventsPreviewDocument,
    {
      variables: {
        filter: {
          after: afterDate,
          before: beforeDate,
        },
      },
    }
  );

  return { data, loading, error, refetch };
}
